import { Component, Input, OnChanges } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { ParticipantMarketType, ParticipantPriceType } from '@cds/betting-offer';
import { StringDictionary } from '@frontend/sports/common/core/utils/extended-types';
import { ISimpleChanges } from '@frontend/sports/common/core/utils/simple-change';
import {
    AntepostParticipantsViewModel,
    FixtureParticipantPriceMap,
    HorseRaceSortingDirection,
    WinGameFixture,
} from '@frontend/sports/racing/feature/models';

import { CrmPromotionProviderService, PromotionMap } from '../../../crm-promotion/crm-promotion-provider.service';
import { HorsesFixtureParticipantHelper } from '../../../horse-racing-shared/services/horses-fixture-participant-helper.service';
import { HorsesFixturePricingHelper } from '../../../horse-racing-shared/services/horses-fixture-pricing-helper.service';
import { HorsesFixtureSortingHelper } from '../../../horse-racing-shared/services/horses-fixture-sorting-helper.service';

@Component({
    selector: 'ms-antepost-participants',
    templateUrl: 'antepost-participants.component.html',
    standalone: false,
})
export class AntepostParticipantsComponent implements OnChanges {
    @Input() fixture: WinGameFixture;

    static readonly emptyViewModel: AntepostParticipantsViewModel<FixtureParticipantPriceMap> = {
        fixture: undefined,
        participants: [],
        options: {},
    };

    crmPromotedOptionIdsMap: StringDictionary<number> = {};
    vm: AntepostParticipantsViewModel<FixtureParticipantPriceMap> = AntepostParticipantsComponent.emptyViewModel;

    constructor(
        private horsesFixturePricingHelper: HorsesFixturePricingHelper,
        private horsesFixtureParticipantHelper: HorsesFixtureParticipantHelper,
        private horsesFixtureSortingHelper: HorsesFixtureSortingHelper,
        private crmPromotionProvider: CrmPromotionProviderService,
    ) {
        this.crmPromotionProvider.promotionsMap$.pipe(takeUntilDestroyed()).subscribe((ids) => this.promotionMapChanged(ids));
    }

    ngOnChanges(changes: ISimpleChanges<AntepostParticipantsComponent>): void {
        if (changes.fixture?.currentValue) {
            this.updateViewModel(changes.fixture.currentValue);
        } else {
            this.vm = AntepostParticipantsComponent.emptyViewModel;
        }
    }

    private promotionMapChanged(promoMap: PromotionMap): void {
        this.crmPromotedOptionIdsMap = promoMap.options;
    }

    private updateViewModel(fixture: WinGameFixture): void {
        const options = this.horsesFixturePricingHelper.getPrices(fixture, ParticipantMarketType.Win, ParticipantPriceType.Fixed);
        let participants = this.horsesFixtureParticipantHelper.getParticipants(fixture.participants);
        participants = this.horsesFixtureSortingHelper.sortParticipantsBy(participants, options, HorseRaceSortingDirection.Odds);

        this.vm = {
            fixture,
            participants,
            options,
        };
    }
}
